import { Button, CircularProgress } from '@mui/material'
import { ReactNode } from 'react'

const SIZE_STYLES = {
  small: {
    circularProgressSize: '1rem'
  },
  medium: {
    circularProgressSize: '1.25rem'
  },
  large: {
    circularProgressSize: '1.5rem'
  }
}

export function LoaderButton({
  onClick,
  disabled,
  loading,
  label,
  variant = 'contained',
  type,
  size = 'medium',
  sx,
  startIcon,
  color,
  disableEndIcon = false
}: {
  onClick?: () => void
  disabled: boolean
  loading: boolean
  label: string
  variant?: 'text' | 'contained' | 'outlined'
  type?: 'button' | 'submit' | 'reset'
  size?: 'small' | 'medium' | 'large'
  sx?: any
  startIcon?: ReactNode
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
  disableEndIcon?: boolean
}) {
  const sizeStyles = SIZE_STYLES[size]

  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      variant={variant}
      size={size}
      {...(type && { type })}
      {...(startIcon && { startIcon })}
      {...(color && { color })}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.5rem',
        ...sx
      }}
    >
      <CircularProgress
        size={sizeStyles.circularProgressSize}
        sx={{
          color: 'inherit',
          visibility: loading ? 'visible' : 'hidden'
        }}
      />
      <span
        style={{
          opacity: loading ? 0.7 : 1,
          whiteSpace: 'nowrap'
        }}
      >
        {label}
      </span>
      {!disableEndIcon && (
        <div
          style={{
            width: sizeStyles.circularProgressSize
          }}
        />
      )}
    </Button>
  )
}
